{
	"application/pdf": "var(--ui-error)",
	"application/vnd.ms-excel": "#1D6F42",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "#1D6F42"
}
